export const FIXED_INCOME_INSTRUMENTS = [
  {
    value: "Commercial Paper",
    label: "Commercial Paper",
    description: "Short-term corporate debt notes (typically under 270 days) with a fixed discount rate.",
  },
  {
    value: "Corporate Bond",
    label: "Corporate Bond",
    description: "Medium to long-term corporate debt securities that pay periodic coupon interest.",
  },
  {
    value: "Placement",
    label: "Placement",
    description: "Bank and money market placements with fixed tenors and negotiated yields.",
  },
  {
    value: "Treasury Bill",
    label: "Treasury Bill",
    description: "Short-term government securities issued at a discount and redeemed at par on maturity.",
  },
];

export const DEFAULT_INSTRUMENT_TYPE = FIXED_INCOME_INSTRUMENTS[0].value;

export const instrumentMetaByValue = FIXED_INCOME_INSTRUMENTS.reduce((acc, instrument) => {
  acc[instrument.value] = instrument;
  return acc;
}, {});

export const instrumentOptions = FIXED_INCOME_INSTRUMENTS.map(({ value, label }) => ({
  value,
  label,
}));

export const normalizeInstrumentType = (value) => {
  if (!value) return DEFAULT_INSTRUMENT_TYPE;
  const key = String(value).trim();
  if (instrumentMetaByValue[key]) return key;
  const lower = key.toLowerCase();
  const matched = FIXED_INCOME_INSTRUMENTS.find((instrument) => instrument.value.toLowerCase() === lower);
  return matched ? matched.value : DEFAULT_INSTRUMENT_TYPE;
};
